export const leaderboardContent = {
  header: "Leaderboard",
  points: "points",
  noLeaders: "No leaders yet!",
};
